/*
 *  Вызывалка для выпадающих поповеров
 *  @author Tretyakov Pavel <tretyakovpavel.ru@gmail.com>
 *  @copyright 2015
 */
define(function (require) {
    'use strict';

    var Marionette = require('marionette');
    var PopoverFactory = require('popovers/factory');

    return Marionette.Behavior.extend({
        ui: {
            element: '.js-popover',
        },

        events: {
            'click @ui.element': 'Show',
        },

        Show: function (e) {
             e.preventDefault();
             e.stopPropagation();

            var $current = $(e.currentTarget);

            if($current.attr('disabled')) {
                return;
            }
            
            var popoverName = $current.attr('data-popover');
            var popoverOpened = $current.attr('data-openedpop');
            var popoverData = $current.data();

            PopoverFactory.create(popoverName, function (PopoverModule) {
                var Popover = new PopoverModule({
                    curElement : $current,
                    popoverData: popoverData
                });

                if (typeof(popoverOpened) == 'undefined') {
                    $current.attr('data-openedpop', true);
                    popoverOpened = false;
                } else if (popoverOpened == 'true') {
                    $current.attr('data-openedpop', false);
                } else {
                    $current.attr('data-openedpop', true);
                }

                if ($current.attr('data-openedpop') == 'true') {
                    $('.webui-popover').remove();
                    Popover.show();
                } else {
                    Popover.hide();
                }
            });
        },

        onShowPopover: function (options) {
            var $current = $(options.target);
            var Popover = options.view;
            var data = options.data || {};

            if($current.attr('disabled') || !Popover) {
                return;
            }

            var popoverOpened = $current.attr('data-openedpop');
            var popover = new Popover({
                curElement: $current,
                popoverData: data
            });

            if (typeof(popoverOpened) == 'undefined') {
                $current.attr('data-openedpop', true);
                popoverOpened = false;
            } else if (popoverOpened == 'true') {
                $current.attr('data-openedpop', false);
            } else {
                $current.attr('data-openedpop', true);
            }

            if ($current.attr('data-openedpop') == 'true') {
                $('.webui-popover').remove();
                popover.show();
            } else {
                popover.hide();
            }

            options.handler && options.handler(popover);
        }
    });
});
